<template>
  <div class="mask" @click="close()">
    <div class="image-review-box" @click.stop="stop()">
      <div class="image-info">
        <div class="left">
          <img v-if="item.type === 0" :src="item.filePath" alt />
          <video autoplay ref="video" v-if="item.type === 1" :src="item.filePath" controls></video>
        </div>
        <div class="right">
          <div class="module-box">
            <h3 class="title">创意说明</h3>
            <p class="desc">{{ item.fileDescription }}</p>
            <ul class="information">
              <li>
                <span class="label">作者：</span>
                <span class="value">{{item.fileAuthor}}</span>
              </li>
              <li>
                <span class="label">发布时间：</span>
                <span class="value">{{item.createTime}}</span>
              </li>
            </ul>
          </div>

          <div class="module-box" v-show="item.labels && item.labels.length > 0">
            <div class="tag-list">
              <div
                class="tag-item"
                v-for="(it, index) in item.labels"
                :class="{ 'hot-tag': it.is_hot }"
                :key="index"
              >{{ it.name }}</div>
            </div>
          </div>

        </div>
      </div>
      <div class="image-similar-list">
        <h3 class="title">相似创意</h3>
        <div class="image-list">
          <waterfall
            :col="waterfallWidth"
            :width="216"
            :gutterWidth="20"
            :data="dataList"
            :scrollObj="'.mask'"
            @loadmore="loadMore"
          >
            <template>
              <div class="image-item" v-for="(item, index) in dataList" :key="index">
                <div class="image-box" @click="reviewImage(item)">
                  <img v-if="item.type === 0 || item.type === 2" :src="item.filePath" alt />
                  <img v-if="item.type === 1" :src="item.fileThumbnailPath" alt />
                  <img
                    src="../assets/images/video-play-icon.png"
                    v-if="item.type === 1"
                    alt
                    class="video-play"
                  />
                </div>
                <div class="info">
                  <h3 class="title">{{ item.fileName }}</h3>
                  <div class="label-list" v-if="item.labels && item.labels.length > 0">
                    <div
                      class="label-item"
                      :class="{ 'hot-tag': it.is_hot }"
                      v-for="(it, idx) in item.labels"
                      :key="idx"
                    >{{ it.name }}</div>
                  </div>
                </div>

                <div class="share">
                  <p>--</p>
                  <p class="time">{{ item.createTime }}</p>
                </div>
              </div>
            </template>
          </waterfall>
        </div>
      </div>

      <!-- <h3 class="title">
        {{ currentItem.fileName }}
        <i class="el-icon-close" @click="close()"></i>
      </h3>
      <div class="image-list">
        <div
          class="all-box"
          :style="{ width: (130 * this.list.length - 20) + 'px', transform: 'translateX(' + offsetX + ')' }"
        >
          <div
            class="image-item"
            :class="{ active: index === currentIndex }"
            @click="changeImage(item, index)"
            v-for="(item, index) in list"
            :key="index"
          >
            <img v-show="item.type === 0" :src="item.filePath" alt />
            <img v-show="item.type === 1" :src="item.fileThumbnailPath" alt />
          </div>
        </div>
      </div>
      <div class="image-box">
        <a
          class="page prev"
          @click="changeImage(list[currentIndex - 1 < 0 ? 0 : currentIndex - 1], currentIndex - 1 < 0 ? 0 : currentIndex - 1)"
        ></a>
        <img v-show="currentItem.type === 0" :src="currentItem.filePath" alt />
        <video ref="video" v-show="currentItem.type === 1" :src="currentItem.filePath" controls></video>
        <a
          class="page next"
          @click="changeImage(list[currentIndex + 1 > list.length - 1 ? list.length - 1 : currentIndex + 1], currentIndex + 1 > list.length - 1 ? list.length - 1 : currentIndex + 1)"
        ></a>
      </div>-->
    </div>

    <i class="close" @click.stop="close"></i>
    <i class="icon prev" @click.stop="changeImage(-1)"></i>
    <i class="icon next" @click.stop="changeImage(1)"></i>
  </div>
</template>
<script>
import { getSimilarFileList } from "../assets/js/api";
import { PromiseWidget } from "../assets/js/tools";
import { LOADING_OPTIONS } from "../assets/tools/common";
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  watch: {
    item(val) {
      this.init();
      document.querySelector(".mask") &&
        document.querySelector(".mask").scrollTop &&
        (document.querySelector(".mask").scrollTop = 0);
    }
  },
  data() {
    return {
      currentPage: 1,
      imageList: [],
      currentIndex: -1,
      waterfallWidth: 5,
      dataList: [],
      myLabel:[
        {name:"快消",is_hot:false},
        {name:"医疗",is_hot:true},
        {name:"传媒",is_hot:true},
        {name:"快消",is_hot:false},
        {name:"快消",is_hot:false},
      ]
    };
  },
  methods: {
    reviewImage(item) {
      this.$emit("changeReview", item);
    },
    changeImage(index) {
      this.$emit("toggleReview", index);
    },
    loadMore() {
      this.currentPage++;
      this.getSimilarFileList();
    },
    init() {
      this.currentPage = 1;
      this.dataList = [];
      this.getSimilarFileList();
    },
    async getSimilarFileList() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const [err, data] = await PromiseWidget.to(
        getSimilarFileList({ id: this.item.id, page: this.currentPage })
      );
      this.$nextTick(() => {
        loading.close();
      });
      if (data && data.code === 200) {
        this.dataList =
          this.currentPage > 1
            ? this.dataList.concat(data.data.data)
            : data.data.data;
      }
    },
    stop() {},
    close() {
      this.$refs.video && this.$refs.video.pause();
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: rgba(229, 229, 229, 0.95);
  padding-top: 60px;
  overflow-y: auto;

  &.dark {
    background-color: rgba(0, 0, 0, 0.8);

    .image-review-box {
      .image-info {
        .left,
        .right {
          background-color: #1f2022;

          .module-box {
            .tag-list {
              .tag-item {
                background-color: #565656;
                border-color: #565656;
                color: #c0c4cc;
                &:hover {
                  border-color: #565656;
                }

                &.hot-tag {
                  color: #fff;
                  border-color: #1983f9;
                  background: linear-gradient(
                    135deg,
                    rgba(25, 131, 249, 1) 0%,
                    rgba(112, 48, 255, 1) 100%
                  );
                  position: relative;

                  &:after {
                    position: absolute;
                    right: -8px;
                    top: -7px;
                    content: " ";
                    width: 20px;
                    height: 14px;
                    background: url(../assets/images/hot-tag-icon.png) no-repeat
                      center center;
                  }
                }
              }
            }
            h3.title {
              color: #fff;
              &:after {
                background: linear-gradient(
                  90deg,
                  rgba(25, 131, 249, 1) 0%,
                  rgba(112, 48, 255, 1) 100%
                );
              }
            }

            p {
              color: #c0c4cc;
            }
          }
        }
      }
      .image-similar-list {
        .title {
          border-bottom-color: #343538;
        }
        .image-list {
          .image-item {
            background-color: #27282a;
            &:hover {
              background-color: #17181a;
            }

            .info {
              border-bottom-color: #343538;
              h3.title {
                color: #fff;
              }
            }
          }
        }
      }
    }
  }

  i.close {
    width: 50px;
    height: 50px;
    background: url(../assets/images/close-icon.png) no-repeat center center;
    position: fixed;
    right: 30px;
    top: 30px;
    cursor: pointer;
  }

  i.icon {
    width: 60px;
    height: 150px;
    top: 50%;
    margin-top: -75px;
    background: url(../assets/images/next-icon.png) no-repeat center center;
    position: fixed;
    cursor: pointer;
    &:hover {
      background: url(../assets/images/next-active-icon.png) no-repeat center
        center rgba(144, 147, 153, 0.3);
    }

    &.prev {
      left: 0;
      transform: rotate(180deg);
      &:hover {
        background: url(../assets/images/next-active-icon.png) no-repeat center
          center rgba(144, 147, 153, 0.3);
        transform: rotate(0deg);
      }
    }

    &.next {
      right: 0;
      transform: rotate(0deg);
      &:hover {
        background: url(../assets/images/next-active-icon.png) no-repeat center
          center rgba(144, 147, 153, 0.3);
        transform: rotate(180deg);
      }
    }
  }

  .image-review-box {
    width: 1152px;
    margin: 0 auto;
    .image-info {
      display: flex;
      justify-content: center;
      align-items: flex-start;

      .left {
        width: 832px;
        padding: 20px;
        background-color: #fff;
        box-sizing: border-box;
        margin-right: 20px;
        min-height: 600px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;

        img,
        video {
          display: block;
          margin: 0;
          max-width: 100%;
          outline: none;
        }

        video {
          max-height: 560px;
        }
      }

      .right {
        width: 300px;
        min-height: 600px;
        background-color: #fff;
        padding: 20px;
        box-sizing: border-box;
        border-radius: 5px;

        .module-box {
          padding-bottom: 10px;
          &:first-child {
            h3.title {
              margin-top: 0;
            }
          }
          h3.title {
            color: #000;
            font-size: 16px;
            font-weight: 600;
            padding-left: 14px;
            box-sizing: border-box;
            width: 100%;
            position: relative;
            margin: 30px 0 10px;
            text-align: left;
            height: 30px;
            line-height: 30px;
            &:after {
              content: " ";
              position: absolute;
              left: 0;
              top: 5px;
              width: 4px;
              height: 16px;
              border-radius: 2px;
              background: linear-gradient(
                180deg,
                rgba(250, 213, 44, 1) 0%,
                rgba(255, 96, 41, 1) 100%
              );
            }
          }

          .tag-list {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            border-top: 1px solid #DCDFE6;
            padding-top: 15px;
            .tag-item {
              padding: 0 8px;
              border: 1px solid #bfbfbf;
              background-color: #f8f8f8;
              border-radius: 5px;
              color: #606266;
              font-size: 12px;
              height: 20px;
              line-height: 20px;
              margin: 0 10px 10px 0;
              cursor: pointer;

              &.hot-tag {
                color: #fff;
                border-color: #ff6029;
                background: linear-gradient(
                  135deg,
                  rgba(250, 213, 44, 1) 0%,
                  rgba(255, 96, 41, 1) 100%
                );
                position: relative;

                &:after {
                  position: absolute;
                  right: -8px;
                  top: -7px;
                  content: " ";
                  width: 20px;
                  height: 14px;
                  background: url(../assets/images/hot-tag-icon.png) no-repeat
                    center center;
                }
              }
              &.active {
                border: 1px solid #1983f9;
              }
            }
          }

          .desc {
            padding: 5px 10px;
            text-align: left;
            margin: 0;
            font-size: 14px;
            word-break: break-all;
            line-height: 24px;
            color: #606266;
            background-color: #F5F5F5;
          }
          .information {
            font-size: 14px;
            li {
              margin-bottom: 10px;
            }
            .label {
              display: inline-block;
              width: 70px;
              
            }
            .value {
              color: #C0C4CC;
            }
          }
        }
      }
    }

    .image-similar-list {
      margin-top: 30px;
      padding-bottom: 50px;
      h3.title {
        color: #606266;
        font-size: 20px;
        font-weight: 400;
        margin: 0;
        padding-bottom: 10px;
        border-bottom: 1px solid #909399;
        text-align: left;
      }

      .image-list {
        padding: 30px 0;
        .image-item {
          background-color: #fff;
          box-shadow: 0px 3px 10px rgba(16, 72, 132, 0.15);
          margin-bottom: 20px;

          &:hover {
            background-color: #fff;
            box-shadow: 0px 6px 12px rgba(11, 75, 143, 0.2);
            transform: translateY(-1px);
            transition: all 0.5s;
          }
        }
        .image-box {
          position: relative;
          img {
            max-width: 100%;
            display: block;
            &.video-play {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate3d(-50%, -50%, 0);
              width: 50px;
              height: 50px;
            }
          }
          cursor: pointer;
        }

        .info {
          padding: 20px 0;
          border-bottom: 1px solid #dcdfe6;
          h3.title {
            padding: 0 16px;
            flex: 1;
            font-size: 14px;
            font-weight: 400;
            margin: 0;
            text-align: left;
            border-bottom: 0;
            color: #303133;
            word-break: break-all;
            p {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              margin: 0 0 0 8px;
              i {
                width: 20px;
                height: 20px;
                background: url(../assets/images/file-size.png) no-repeat;
              }
            }
          }

          p.desc {
            color: #909399;
            margin-top: 10px;
            text-align: left;
            padding: 0 16px;
          }

          .label-list {
            display: flex;
            padding: 0 16px;
            justify-content: flex-start;
            align-items: center;
            margin-top: 20px;
            .label-item {
              padding: 0 8px;
              height: 22px;
              line-height: 22px;
              background-color: #565656;
              color: #c0c4cc;
              font-size: 12px;
              border-radius: 5px;
              margin-right: 10px;

              &.hot-tag {
                color: #fff;
                border-color: #ff6029;
                background: linear-gradient(
                  135deg,
                  rgba(250, 213, 44, 1) 0%,
                  rgba(255, 96, 41, 1) 100%
                );
                position: relative;

                &.active {
                  background: #fff;
                  color: #ff6029;
                  border-color: #ff6029;
                }

                &:after {
                  position: absolute;
                  right: -8px;
                  top: -7px;
                  content: " ";
                  width: 20px;
                  height: 14px;
                  background: url(../assets/images/hot-tag-icon.png) no-repeat
                    center center;
                }
              }
            }
          }
        }

        .share {
          padding: 10px 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          i {
            width: 20px;
            height: 20px;
            background: url(../assets/images/google-icon.png) no-repeat;
            &.facebook {
              background: url(../assets/images/facebook-icon.png) no-repeat;
            }
          }

          p {
            margin: 0;
            color: #606266;
          }
        }
      }
    }
  }
}
</style>